import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilters } from '../../../../reducers/filtersSlice';

const RoomRadio = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { room } = filtersCollection
  const dispatch = useDispatch();

  const optionsNumber = 5
  const roomsInputs = [{ inputName: 'min_room_number', displayName: 'Nombre de pièce(s) minimum ?' }, { inputName: 'min_bedroom_number', displayName: 'Nombre de chambre(s) minimum ?' }]

  return(
    <div className='vesta-flex-col-start vesta-gap-15'>
      {roomsInputs.map(({ inputName, displayName }) => (
        <div key={inputName} className='vesta-checkbox-number-container vesta-flex-col-start vesta-gap-10'>
          <div className='typo-bold-content vesta-whitespace-nowrap'>{displayName}</div>

          <div className='vesta-flex-row-start vesta-gap-8'>
            {[...Array(optionsNumber)].map((_, index) =>
              <div key={index}>
                <input
                  id={`${index + 1}-${inputName}${index + 1 > 1 ? 's' : ''}`}
                  type='radio'
                  value={inputName === 'min_room_number' ? index + 1 : index}
                  name={inputName}
                  checked={inputName === 'min_room_number' ? room[inputName] == index + 1 : room[inputName] == index}
                  onChange={(e) => dispatch(updateFilters(
                    {...filtersCollection,
                      room: {...room, [inputName]: e.target.value}
                    }
                  ))}
                />

                <label
                  htmlFor={`${index + 1}-${inputName}${index + 1 > 1 ? 's' : ''}`}
                  className='vesta-checkbox-number vesta-checkbox-number--primary typo-h4 vesta-flex-row-center'
                >
                  {inputName === 'min_room_number' ? index + 1 : index}
                </label>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
};

export default RoomRadio;
